<template>
  <step-card :custom-style="customStyle" :step-name="name" :step-number="number" :custom-form-class="cardActive">
    <div slot="form-main-content" class="files-form">
        <step-card-toolbar slot="toolbar" :has-border='true'>
          <img src="../../assets/icons/datoteka.svg" alt="" class="toolbar__img" slot="toolbar-image">

          <template slot="toolbar-text">
            <slot name="toolbar-text">
              <span class="toolbar__text">{{ fileCount }} {{ totalSize }}</span>
            </slot>
          </template>

          <template slot="toolbar-action">
            <vue-plupload @added="handleAdded" @progress="handleProgress" @error="handleError" @uploaded="handleUploaded" @before="handleBeforeUpload" :options="uploadOpt"></vue-plupload>
          </template>
        </step-card-toolbar>

        <div class="files-form__content">
          <div class="files-form__description" v-if="description">
            <p v-html="description"></p>
          </div>
          <ul class="files-form__list">
            <li class="files-form__item" v-for="(file, index) in $store.state.files.slice().reverse()" :key="file.name + '' + index">
              <file-item :file="file" :index="index" />
            </li>
          </ul>
          <error-popup :message="$store.state.errors.network" v-if="$store.state.errors.network" />
        </div>
    </div>
    <template slot="form-extra-content" v-if="showCommentField">
      <textarea
        maxlength="1000"
        name="message"
        class="files-form__message"
        :placeholder="$t('filesCard.textAreaPlaceholder')"
        v-model="comment"
        @input="setComment"
        @mouseover="showPlaceholder"
        @mouseleave="hidePlaceholder" />
      <error-popup :message="$store.state.errors.comment" v-if="$store.state.errors.comment" :top-offset="200" />
    </template>
  </step-card>
</template>

<script>
import { search, prettifySize, trimOpis } from '@/utils';

import FileItem from './FilesCardItem.vue'
import StepCard from '../step/StepCard'
import StepCardToolbar from '../step/StepCardToolbar.vue'
import VuePlupload from '../ui/VuePlupload'
import ErrorPopup from '../ui/ErrorPopup'

export default {
  name: 'FileList',
  components: {
    StepCard,
    StepCardToolbar,
    VuePlupload,
    FileItem,
    ErrorPopup,
  },
  props: {
    number: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    servletUrl: {
      type: String,
      default: "/UploadServlet"
    },
    url: {
      type: String
    },
    showCommentField: {
      type: Boolean,
      default: false,
    },
    uploadOpt: {
      type: Object,
      default: function() {
        return {
          url: this.servletUrl,
          urlcheck: '/UploadCheck',
          chunk_size: '1mb',
          dragdrop: false,
          filters: {
              max_file_size: '10gb',
              mime_types: [{
                title: "Large files",
                extensions: "*"
              }]
          },
          multipart_params: {
            password: this.$store.state.password,
            paketUrl: this.$route.params.id
          }
        }

      }
    }
  },
  data () {
    return {
      state: this.$store.state,
      log: "",
      customStyle: {
      },
      comment: null,
    }
  },
  methods: {
    setComment() {
      let trimmed = trimOpis(this.comment, 1000);
      if (this.comment.length > trimmed.length) {
        this.comment = trimmed
      }
      this.$store.setComment(this.comment)
    },
    handleBeforeUpload: function(up, file) {
      this.uploadOpt.multipart_params.fileid = file.id
      this.uploadOpt.multipart_params.filename = file.name
      this.uploadOpt.multipart_params.id = file.id
      up.setOption("multipart_params", this.uploadOpt.multipart_params)

      let data = "fileid=" + encodeURIComponent(file.id) + "&filename=" + encodeURIComponent(file.name)
      if (this.$route.params.id) {
        data +=  "&paketUrl=" + encodeURIComponent(this.$route.params.id)
      }

      if (this.uploadOpt.urlcheck != null) {
        this.$http.post(this.uploadOpt.urlcheck, data, {
          credentials: true,
          headers: {
            'Content-Type': "application/x-www-form-urlencoded"
          }
        }).then(response => {
          file.startsize = response.filesize;
          file.loaded = response.filesize;
        }, response => {
          // error
        })
      }
      if (this.$store.state.errors.network) {
        this.$store.resetError("network")
      }
      // Prevent default actions
      return false;
    },
    handleAdded: function (uploader, files) {
      files.forEach( file => {
        this.$store.addFiles({
          id: file.id,
          name: file.name,
          size: file.size,
          percent: file.percent
        })
      });
      uploader.start()
    },

    handleProgress: function (uploader, file) {
      var foundFileIndex = search(file.id, 'id', this.$store.state.files)
      this.$store.state.files[foundFileIndex].percent = file.percent
    },

    handleError: function (uploader, err) {
      this.log += "upload error:\n======\n" + JSON.stringify(err) + "\n======\n";
      if (err.code === -200) {
        this.$store.setErrors({
          network: this.$t('errors.networkError')
        })
        const self = this;
        setTimeout(function () {
          uploader.files.forEach(function(file) {
            // Only set those file that are not finished yet
            if (file.status === 4) {
              file.status = 1;
            }
          })
          self.$store.resetError("network")
          uploader.start();
        }, 1000 * 30)
      }
    },

    handleUploaded: function (uploader, file, result) {
      // this.$emit('uploaded')

      let shouldRestart = false;
      uploader.files.forEach(function(file) {
        if (file.status === 4) {
          file.status = 1;
          shouldRestart = true
        }
      })

      if (shouldRestart) {
        uploader.start();
      }
    },
    showPlaceholder() {
      if (this.browserIE9) {
        this.$store.setErrors({
          comment: this.$t('errors.comment')
        })
      }
    },
    hidePlaceholder() {
      if (this.browserIE9) {
        this.$store.resetError("comment")
      }
    },
  },
  computed: {
    fileCount() {
      let finalText = this.$tc('files', this.$store.state.files.length, {count: this.$store.state.files.length})
      return finalText
    },
    totalSize() {
      var total = 0
      this.$store.state.files.forEach(file => total+=file.size)
      return prettifySize(total, '/ ')
    },
    fetchPassword() {
      return this.$store.state.password
    },
    cardActive() {
      if (!this.$store.state.files.length) {
        return 'step-form--active'
      }
    },
    browserIE9() {
      return window.ltie10;
    },
  },
}
</script>

<style lang="scss">
.files-form {
  min-height: 170px;

  &__content {
  }

  &__list {
    list-style: none;
  }

  &__item {
    padding-top: 9px;
    position: relative;
  }

  &__description {
    border-bottom: 1px solid #e7e7e7;
    padding: 9px 0;
    font-weight: 600;
  }

  &__message {
    width: 100%;
    min-height: 80px;
    border: none;
    padding: 9px 15px 0 15px;
    border-top: 1px solid #e7e7e7;

    font-size: 13px;
    resize: vertical;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/files/FilesCard.vue